import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { AuthProvider, useAuth } from "utils/AuthContext.js";
import LogoLoader from "components/Custom/LogoLoader.js";


import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts

import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

// views without layouts

import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
import FAQ from "views/FAQ.js";
import Mobile from "views/Mobile.js";

function PrivateRoute({ component: Component, ...rest }) {
  const { loggedIn, loading } = useAuth()

  return (
    <Route
      {...rest}
      render={(props) => {
        // no roar/splash here: Admin.js owns the final loading reveal to avoid a double animation
        if (loading) {
          return <LogoLoader />;
        }

        return loggedIn
          ? <Component {...props} />
          : <Redirect to="/login" />
      }}
    />
  )
}

function AdminRoute(props) {
  const isMobileMode = window.sessionStorage.getItem("enarm_mobile_mode") === "1";

  if (isMobileMode) {
    const mobilePath = window.location.pathname.replace(/^\/admin/, "/mobile");
    return <Redirect to={`${mobilePath}${window.location.search}${window.location.hash}`} />;
  }

  return <PrivateRoute {...props} />;
}

const root = createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>
    <BrowserRouter>
      <Switch>
        {/* add routes with layouts */}
        <AdminRoute path="/admin" component={Admin} />
        <PrivateRoute path="/mobile" component={Mobile} />
        <Route path="/auth" component={Auth} />
        {/* add routes without layouts */}
        <Route path="/landing" exact component={Landing} />
        <Route path="/profile" exact component={Profile} />
        <Route path="/faq" exact component={FAQ} />
        <Route path="/" exact component={Landing} />
        {/* add redirect for first page */}
        <Redirect from="*" to="/" />
      </Switch>
    </BrowserRouter>
  </AuthProvider>
);
